export let ContentPageDisplayModes = /*#__PURE__*/function (ContentPageDisplayModes) {
  ContentPageDisplayModes["COMPARISON_ITEM"] = "Comparison Item";
  ContentPageDisplayModes["PROMOTION"] = "Promotion";
  ContentPageDisplayModes["FEATURE"] = "Feature";
  ContentPageDisplayModes["BASIC_CONTENT"] = "basicContent";
  return ContentPageDisplayModes;
}({});
export function isPromotionFeature(arg) {
  return arg.displayMode === ContentPageDisplayModes.FEATURE;
}
export function isTermsModule(arg) {
  return arg.slug !== undefined;
}
export function isDisplayMode(mode, toCompare) {
  return mode === toCompare;
}